import {useCallback, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectIsPremium} from '~/CreateFabricInvitation/reducers/fabricTemplate/selectors';
import {toggleOption} from '~/common/fabric/reducers/giftingOptions/actions';
import {selectHostPhotoGalleryEnabled} from '~/common/fabric/reducers/giftingOptions/selectors';
import {UPSELL_MODES} from '~/common/fabric/UpsellModal/UpsellModal';
import {Typography} from '~library/atoms/Typography';
import {AddPhotosLineIcon} from '~library/svg/AddPhotosLineIcon';
import {OptionWrapper} from './OptionWrapper';

export const HostPhotoGallery = ({setToToggleOff, toggleUpsellModal}) => {
  const dispatch = useDispatch();
  const isPremium = useSelector(selectIsPremium);
  const giftingOptions = useSelector(({giftingOptions: options}) => options);

  const isHostPhotoGalleryEnabled = useSelector(selectHostPhotoGalleryEnabled);

  const onEnableHostPhotos = useCallback(() => {
    if (isPremium) {
      dispatch(toggleOption(giftingOptions, 'event_option_enable_host_photo_gallery', true));
    } else {
      setToToggleOff(UPSELL_MODES.HOST_PHOTO_GALLERY);
      toggleUpsellModal(UPSELL_MODES.HOST_PHOTO_GALLERY);
    }
  }, [
    isPremium,
    dispatch,
    giftingOptions.options,
    giftingOptions,
    setToToggleOff,
    toggleUpsellModal,
  ]);

  const onDisableHostPhotos = useCallback(() => {
    dispatch(toggleOption(giftingOptions, 'event_option_enable_host_photo_gallery', false));
  }, [dispatch, giftingOptions.options, giftingOptions]);

  const subtitle = useMemo(
    () =>
      isPremium
        ? 'Display photos within a featured gallery on your Invitation.'
        : <>
            <Typography color="premiumColor" variant="list1" as="span">
              Upgrade to Premium
            </Typography>
            &nbsp;to display photos within a featured gallery on your Invitation.
          </>,
    [isPremium]
  );

  return (
    <OptionWrapper
      icon={<AddPhotosLineIcon />}
      title="Host photo gallery"
      subtitle={subtitle}
      onEdit={onEnableHostPhotos}
      isActive={isHostPhotoGalleryEnabled}
      onRemove={onDisableHostPhotos}
    />
  );
};
